import { useApiClient } from "@/modules/api/apiClient.store.ts";
import type { AddMethodProps } from "@/modules/billing/choose_method/AddMethodParams.ts";
import { FormBox } from "@/modules/billing/choose_method/FormBox.tsx";
import { makeApplyForInvoicePaymentRequest } from "@/modules/billing/choose_method/addMethodUtils.ts";
import { invoiceAddNoticeAtom } from "@/modules/billing/choose_method/invoiceMethodLogic.tsx";
import { SupportEmail } from "@/modules/support/SupportLink.tsx";
import { Trans } from "@lingui/react/macro";
import { useAtomValue } from "jotai/react";
import { useImperativeHandle } from "react";

export default function InvoiceForm({ actionsRef }: AddMethodProps) {
    //#region Hooks
    const invoiceAddNotice = useAtomValue(invoiceAddNoticeAtom);
    const apiClient = useApiClient();

    useImperativeHandle(actionsRef, () => ({
        // eslint-disable-next-line @typescript-eslint/require-await
        async validate() {
            return true;
        },
        async addPaymentMethod({ account }) {
            await makeApplyForInvoicePaymentRequest(apiClient, account.id);
        },
    }));
    //#region Hooks

    return (
        <FormBox>
            <p>
                <Trans>
                    If the invoice payment method is not activated instantly, we will contact you with more details. If
                    you do not receive an email from us soon or the invoice payment does not become active, you can
                    contact us at <SupportEmail />.
                </Trans>
            </p>
            {invoiceAddNotice && <p className="mt-2">{invoiceAddNotice}</p>}
        </FormBox>
    );
}
